// extracted by mini-css-extract-plugin
export default {"detailing-panel-content-table":"styles_detailing-panel-content-table__Fhce1","last-cell":"styles_last-cell__nL1+K","products-pagination":"styles_products-pagination__oMopu"};